import { render, staticRenderFns } from "./CFormProject_IRTC.vue?vue&type=template&id=4a14b48b&scoped=true&"
import script from "./CFormProject_IRTC.vue?vue&type=script&lang=js&"
export * from "./CFormProject_IRTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a14b48b",
  null
  
)

export default component.exports